// Ctrl/⌘ + Shift + P toggles privacy mode from anywhere (task 402.10). Its own module so the toggle file exports
// components only, which keeps fast refresh working.

import { useEffect } from 'react';
import { usePrivacyStore } from '../../stores/privacyStore';

const IS_MAC = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);

export const PRIVACY_SHORTCUT = IS_MAC ? '⌘ ⇧ P' : 'Ctrl Shift P';

export function usePrivacyShortcut(): void {
  const toggle = usePrivacyStore((s) => s.toggle);

  useEffect(() => {
    const onKey = (e: KeyboardEvent): void => {
      if (!(e.ctrlKey || e.metaKey) || !e.shiftKey) return;
      if (e.key.toLowerCase() !== 'p') return;
      // Never steal the key while someone is typing.
      const target = e.target as HTMLElement | null;
      const tag = target?.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || target?.isContentEditable) return;
      e.preventDefault();
      toggle();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [toggle]);
}
